import React, { useMemo } from 'react';
import DynamicsDetailPage from '../DynamicsDetailPage';
import { getApiV1Url } from '../config/api';
import axios from 'axios';
import { Certif } from '../CertificatesPage';

interface DynamicsLabsPageProps {
    filteredCertif?: Certif[];
}

const DynamicsLabsPage: React.FC<DynamicsLabsPageProps> = ({ filteredCertif: propFilteredCertif }) => {
    const [certif, setCertif] = React.useState<Certif[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        if (propFilteredCertif !== undefined) {
            setCertif(propFilteredCertif);
            setLoading(false);
        }
    }, [propFilteredCertif]);
    
    React.useEffect(() => {
        if (propFilteredCertif !== undefined) {
            return;
        }
        
        const fetchData = async () => {
            try {
                const access = localStorage.getItem('access');
                const response = await axios.get<Certif[]>(getApiV1Url('CERTIFICATES'), {
                    headers: { Authorization: `Bearer ${access}` },
                });
                setCertif(response.data);
            } catch (error) {
                console.error('Error fetching certificates:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const filteredCertif = propFilteredCertif !== undefined ? propFilteredCertif : certif;

    const getDynamicsData = useMemo(() => {
        return () => {
            const labCounts = new Map<string, Map<string, number>>();
            const nameToNumber = new Map<string, string>();
            const allLabs = new Set<string>();
            filteredCertif.forEach(item => {
                if (!item.cert_reg_data) return;
                const year = String(item.cert_reg_data.substring(0, 4));
                if (!labCounts.has(year)) labCounts.set(year, new Map());
                const m = labCounts.get(year)!;
                const names = [item.lan_name_1, item.lan_name_2, item.lan_name_3];
                const numbers = [(item as any).lab_number_1, (item as any).lab_number_2, (item as any).lab_number_3];
                names.forEach((name, idx) => {
                    const n = (name || '').trim();
                    if (n && n.toLowerCase() !== 'отсутствует') {
                        m.set(n, (m.get(n) || 0) + 1);
                        allLabs.add(n);
                        const num = (numbers[idx] || '').toString().trim();
                        if (num && !nameToNumber.has(n)) nameToNumber.set(n, num);
                    }
                });
            });
            const labNames = Array.from(allLabs).sort();
            const years = Array.from(new Set(filteredCertif.map(i => i.cert_reg_data ? i.cert_reg_data.substring(0,4) : '').filter(Boolean))).sort();
            return { years, names: labNames, counts: labCounts, nameToNumber } as any;
        };
    }, [filteredCertif]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                Загрузка...
            </div>
        );
    }

    return (
        <DynamicsDetailPage
            getDynamicsData={getDynamicsData}
            title="Лаборатории - Динамика"
            chartTitle="Динамика сертификатов по лабораториям"
            maps={{ nameToNumber: (getDynamicsData() as any).nameToNumber }}
        />
    );
};

export default DynamicsLabsPage;

